import smartyEndpoints from "./endpoints/smarty.endpoints";

/**
 * Reverse geocode coordinates to get city/address information using Smarty Streets
 * @param {number} latitude - Latitude coordinate
 * @param {number} longitude - Longitude coordinate
 * @returns {Promise<{results: Array<{address: {city: string, state_abbreviation: string, street: string, zipcode: string}}>}>}
 */
export async function reverseGeocode(latitude, longitude) {
    return smartyEndpoints
        .reverseGeocode({ params: { latitude, longitude } })
        .then((response) => response.data)
        .catch((error) => {
            console.error('Smarty reverse geocode error:', error);
            return { results: [] };
        });
}
